import { render, staticRenderFns } from "./card-coupon.vue?vue&type=template&id=0f41c28d&scoped=true"
import script from "./card-coupon.vue?vue&type=script&lang=js"
export * from "./card-coupon.vue?vue&type=script&lang=js"
import style0 from "./card-coupon.vue?vue&type=style&index=0&id=0f41c28d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f41c28d",
  null
  
)

export default component.exports